var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFullScreen = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.5 1.5C16.0858 1.5 15.75 1.83579 15.75 2.25C15.75 2.66421 16.0858 3 16.5 3H19.9393L12 10.9393L4.06064 3L7.5 3C7.91421 3 8.25 2.66421 8.25 2.25C8.25 1.83579 7.91421 1.5 7.5 1.5H2.25C1.83579 1.5 1.5 1.83579 1.5 2.25V7.5C1.5 7.91421 1.83579 8.25 2.25 8.25C2.66421 8.25 3 7.91421 3 7.5L3 4.06068L10.9393 12L3 19.9393V16.5C3 16.0858 2.66421 15.75 2.25 15.75C1.83579 15.75 1.5 16.0858 1.5 16.5V21.75C1.5 22.1642 1.83579 22.5 2.25 22.5H7.5C7.91421 22.5 8.25 22.1642 8.25 21.75C8.25 21.3358 7.91421 21 7.5 21H4.06066L12 13.0607L19.9393 21H16.5C16.0858 21 15.75 21.3358 15.75 21.75C15.75 22.1642 16.0858 22.5 16.5 22.5H21.75C22.1642 22.5 22.5 22.1642 22.5 21.75V16.5C22.5 16.0858 22.1642 15.75 21.75 15.75C21.3358 15.75 21 16.0858 21 16.5V19.9393L13.0607 12L21 4.06064V7.5C21 7.91421 21.3358 8.25 21.75 8.25C22.1642 8.25 22.5 7.91421 22.5 7.5V2.25C22.5 1.83579 22.1642 1.5 21.75 1.5H16.5Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFullScreen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/full-screen.4e0b2cf6ba93c17b9b4a5882ea8e73f7.svg";